export default { sha: 'a92a063066d522f89129bf07a128f04f67838b05', buildNumber: 'undefined' }
